import Vue from 'vue'
import router from './router'
import VueLocalForage from 'vue-localforage'
import VueTouch from 'vue-touch'
// https://github.com/euvl/vue-js-modal
import VModal from 'vue-js-modal'
import Vfm from 'vue-final-modal'
import Ripple from 'vue-ripple-directive'
import './registerServiceWorker'
import {
  Input,
  InputNumber,
  Radio,
  Checkbox,
  Switch,
  Select,
  Option,
  Button,
  DatePicker,
  Rate,
  Form,
  FormItem,
  Icon,
  Collapse,
  CollapseItem,
  Loading,
  Message,
  Progress,
  MessageBox
} from 'element-ui'

import 'element-ui/lib/theme-chalk/icon.css'
import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'

import App from './App'
import App_dev from './App_dev'

import Axios from './plugins/my-axios'
import DeviceLib from './plugins/device-lib'
import GtmDataLayer from './plugins/gtm-datalayer'
import EventHub from './plugins/event-hub'
import Emitter from './plugins/emitter'
import GlobalVar from './plugins/global-var'

import FirebaseLib from './plugins/firebase-lib.js'
import FormLib from './plugins/form-lib'

import Site from './plugins/site'
import Varuna from './plugins/varuna'
import Yagi from './plugins/yagi'
// import City from './plugins/tryt-city-master'
import YourYagi from './components/YourYagi'
import VueCookies from 'vue-cookies'
import YagiprimePaymentService from './services/YagiprimePaymentService'

import SmartBanner from 'smart-app-banner'
import 'smart-app-banner/dist/smart-app-banner.css'

// 文章校正機能（v-proofread ディレクティブ）
import { registerProofreading } from '@/proofreading'

Vue.use(VueCookies)

locale.use(lang)

Vue.use(router)
Vue.use(Site)
Vue.use(Axios)

/* element-ui */
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(Switch)
Vue.use(Select)
Vue.use(Option)
Vue.use(Button)
Vue.use(Rate)
Vue.use(DatePicker)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Icon)
Vue.use(Collapse)
Vue.use(CollapseItem)
// Vue.use(MessageBox)
Vue.use(Loading.directive)
Vue.prototype.$message = Message
// Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.use(Progress)

Vue.use(VueLocalForage)
Vue.use(VueTouch, { name: 'v-touch' })
Vue.use(VModal)
Vue.use(Vfm())

Vue.use(EventHub)
Vue.use(Emitter)
Vue.use(DeviceLib)
Vue.use(GtmDataLayer)
Vue.use(FormLib)
Vue.use(FirebaseLib)
Vue.use(Varuna)
Vue.use(Yagi)
Vue.use(GlobalVar)
Vue.use(YagiprimePaymentService)

// Vue.use(City)

// globally (in your main .js file)
Vue.component('your-yagi', YourYagi)

Ripple.color = 'rgba(255, 255, 255, 0.25)'
Vue.directive('ripple', Ripple)

// 文章校正機能（v-proofread）
registerProofreading(Vue)

Vue.config.productionTip = false
const url = new URL(window.location.href)
const params = url.searchParams

// if  (process.env.VUE_APP_MODE == 'development' || process.env.VUE_APP_MODE == 'staging' && false) {
if (false) {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    template: '<App_dev/>',
    components: { App_dev },
    created () {
      new SmartBanner({
        daysHidden: 15, // days to hide banner after close button is clicked (defaults to 15)
        daysReminder: 90, // days to hide banner after "VIEW" button is clicked (defaults to 90)
        title: '履歴書作成',
        author: 'Yagish',
        button: 'インストール',
        store: {
          ios: 'On the App Store',
          android: 'In Google Play'
        },
        price: {
          ios: '無料',
          android: '無料'
        }
        // , theme: '' // put platform type ('ios', 'android', etc.) here to force single theme on all device
        // , icon: '' // full path to icon image if not using website icon image
      })
    }
  })
} else if (params.get('appbnr') == 'n') {
  new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
  })
} else {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App },
    created () {
      new SmartBanner({
        daysHidden: 15, // days to hide banner after close button is clicked (defaults to 15)
        daysReminder: 90, // days to hide banner after "VIEW" button is clicked (defaults to 90)
        title: '履歴書作成',
        author: 'Yagish',
        button: 'インストール',
        store: {
          ios: 'On the App Store',
          android: 'In Google Play'
        },
        price: {
          ios: '無料',
          android: '無料'
        }
        // , theme: '' // put platform type ('ios', 'android', etc.) here to force single theme on all device
        // , icon: '' // full path to icon image if not using website icon image
      })
    }
  })
}
